import React from 'react'

// Catches render/runtime errors in the subtree and shows the actual message
// on screen instead of a blank page. Without this, one component throwing
// unmounts the whole React root (blank app). Keep it dependency-free.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null, info: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    this.setState({ info })
    try { console.error('[ErrorBoundary]', error, info) } catch {}
  }

  render() {
    const { error, info } = this.state
    if (!error) return this.props.children

    const msg = (error && (error.message || String(error))) || 'Unknown error'
    const stack = (info && info.componentStack) || (error && error.stack) || ''
    return (
      <div style={{ padding: '2rem 1.25rem', fontFamily: "'DM Sans',sans-serif", color: '#1A2820', maxWidth: 640, margin: '0 auto' }}>
        <div style={{ fontSize: '2rem', marginBottom: '.5rem' }}>⚠️</div>
        <div style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.3rem', marginBottom: '.5rem' }}>Something went wrong</div>
        <div style={{ fontSize: '.85rem', color: '#5A7065', lineHeight: 1.6, marginBottom: '1rem' }}>
          This screen hit an error. The rest of the app still works — go back and try another tab.
        </div>
        <div style={{ background: '#FEF2F2', border: '1px solid #FCA5A5', borderRadius: 12, padding: '.85rem 1rem', marginBottom: '1rem' }}>
          <div style={{ fontWeight: 700, color: '#B91C1C', fontSize: '.82rem', marginBottom: '.35rem' }}>{msg}</div>
          {stack && (
            <pre style={{ fontSize: '.62rem', color: '#7F1D1D', whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: 0, maxHeight: 260, overflow: 'auto' }}>
              {String(stack).trim().split('\n').slice(0, 12).join('\n')}
            </pre>
          )}
        </div>
        <button onClick={() => this.setState({ error: null, info: null })}
          style={{ background: '#235233', color: '#fff', border: 'none', borderRadius: 10, padding: '.7rem 1.4rem', fontWeight: 700, fontSize: '.85rem', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>
          Try again
        </button>
      </div>
    )
  }
}
